export default {
    en: {
        tab:{
            master: '평가마스터',
        },
        list:{
            master:{
                evalNm:'평가명',
                applcRsltType:'적용성과',
                evalItemNm:'평가항목',
            }
        },
        modal:{
            evalStdrNm:'평가명',
            evalStdrEngNm:'평가명(영문)',
            useYn:'사용여부',
            dispOrder:'표시순서',
            gradeNm:'등급명',
            gradeEngNm:'등급명(영문)',
            gradeValue:'값',
            comprOprtorValue:'연산자',
            score:'점수(비율)',
            addScore:{
                modalTitle:'평가기준점수(비율)',
                copyStdr:'평가기준 복사대상',
            },
            detailScore:{
                modalTitle:'평가기준점수(비율)',
            },
        },
    },
    ko: {
        tab:{
            master: '평가마스터',
        },
        list:{
            master:{
                evalNm:'평가명',
                applcRsltType:'적용성과',
                evalItemNm:'평가항목',
            }
        },
        modal:{
            evalStdrNm:'평가명',
            evalStdrEngNm:'평가명(영문)',
            useYn:'사용여부',
            dispOrder:'표시순서',
            gradeNm:'등급명',
            gradeEngNm:'등급명(영문)',
            gradeValue:'값',
            comprOprtorValue:'연산자',
            score:'점수(비율)',
            addScore:{
                modalTitle:'평가기준점수(비율)',
                copyStdr:'평가기준 복사대상',
            },
            detailScore:{
                modalTitle:'평가기준점수(비율)',
            },
        },
    }
}